import React, { Component, Fragment } from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Select from './form/Select'
import { DoubleAxisQuestion } from '../Models/Question'

import '../assets/css/page.css'
import { trackBuilderLogicEdit } from '../utils/MixpanelManager'

const PageRoutingWrapper = ({ skipLogicConfig, children, hide }) => {
    if (hide) {
        return (
            <div className="no-options">
                <b>{i18n.t('skipLogicModal.noPageOptionsAvailable')}</b>
            </div>
        )
    }

    if (skipLogicConfig.type === 'page') {
        return (
            <div className="skip-logic-page-logic-table">
                <div className="skip-logic-page-logic-table-header">
                    {i18n.t('skipLogicModal.pageSkipLogicExists')}
                </div>

                <div className="skip-logic-page-logic-table-content">
                    <p style={{ fontSize: 12 }}>{i18n.t('skipLogicModal.pageSkipLogicExistsDescription')}</p>

                    <br />

                    {children}
                </div>
            </div>
        )
    }

    return children
}

@observer
class PageRouting extends Component {
    @observable selections = observable.map({})

    componentWillMount() {
        this.initSkiptoPageLogic()
    }

    initSkiptoPageLogic = () => {
        const { store } = this.props
        const { survey, skipLogicConfig } = store
        this.page = survey.pages[skipLogicConfig.pageIndex]
        let index = 0
        this.page_options = survey.pages.reduce((arr, page) => {
            if (index > skipLogicConfig.pageIndex) {
                arr.push({
                    value: page.id,
                    label: `${i18n.t('s_page')}: ${(index + 1)}${(page.title ? (` - ${page.title}`) : '')}`,
                })
            }
            index += 1
            return arr
        }, [{
            value: -1, label: i18n.t('form.general.please_select_ellipsis'),
        }])
        const pageQuestions = this.page.questions.map((pageQuestion) => pageQuestion.id)
        pageQuestions.forEach((pageQuestionId) => {
            this.selections.set(pageQuestionId, {
                label: '',
                value: '',
            })
        })
        this.skipLogic = survey.skipLogic.reduce((map, sl) => {
            const triggerQuestionId = sl.trigger
                ? sl.trigger.condition.pageQuestionId
                : sl.triggerGroups[0].children[0].triggers[0].condition.pageQuestionId
            console.log(triggerQuestionId, JSON.stringify(sl.toJSON(), null, 4))
            if (sl.action.kind === 'SkipToPage') {
                const condition = sl.trigger
                    ? sl.trigger.condition
                    : sl.triggerGroups[0].children[0].triggers[0].condition
                let key
                console.log(`condition ${condition}`)
                if (pageQuestions.indexOf(triggerQuestionId) > -1) {
                    key = condition.set1 + (condition.set2 ? `|${condition.set2}` : '')
                }
                map[key] = sl
                const skipPage = survey.pages.find((page) => page.id === sl.action.pageId)
                if (skipPage && skipPage.priority > this.page.priority) {
                    const title = skipPage.title ? ` - ${skipPage.title}` : ''
                    this.selections.set(key, {
                        value: sl.action.pageId,
                        label: `${i18n.t('s_page')}: ${skipPage.priority} ${title}`,
                    })
                } else if (skipPage.priority < this.page.priority) {
                    this.selections.set(key, {
                        value: sl.action.pageId,
                        label: 'Invalid logic -- remove',
                    })
                } else {
                    this.selections.set(key, {
                        value: sl.action.pageId,
                        label: 'Target page does not exist -- remove',
                    })
                }
            }
            return map
        }, {})
        console.log(`initSkiptoPageLogic ${JSON.stringify(this.skipLogic)}`)
    }

    setRouting = (option, obj, col, pageQuestion) => {
        const { store } = this.props
        const { survey } = store
        const logicId = option.id + (col ? (`|${col.id}`) : '')
        const questionType = pageQuestion.question.questionTypeCode
        // console.log({ logicId, skipLogic: this.skipLogic, parent: option.parentId})

        if (!this.skipLogic[logicId] && obj && obj.value !== -1) {
            console.log(`Create new SkipToPage logic ${obj.value} ${pageQuestion.id}`)
            trackBuilderLogicEdit(store, { action: 'add/edit', logic_type: 'routing', type: 'question', question_type: questionType, source: 'menu' })
            this.skipLogic[logicId] = survey
                .newSkipToPage(obj.value, pageQuestion.id, option.id, col, option.parentId)
            console.log(JSON.stringify(this.skipLogic[logicId], null, 4))
            this.selections.set(logicId, obj)
            console.log(this.selections.get(logicId))
            this.skipLogic[logicId].save(store)
        } else if (obj && obj.value !== -1) {
            trackBuilderLogicEdit(store, { action: 'add/edit', logic_type: 'routing', type: 'question', question_type: questionType, source: 'menu' })
            this.skipLogic[logicId].action.pageId = obj.value
            this.skipLogic[logicId].save(store)
            this.selections.set(logicId, obj)
        } else if (this.selections.has(logicId) && this.skipLogic[logicId]) {
            trackBuilderLogicEdit(store, { action: 'delete', logic_type: 'routing', type: 'question', question_type: questionType, source: 'menu' })
            this.skipLogic[logicId].remove(store)
            Reflect.deleteProperty(this.skipLogic, logicId)
            this.selections.set(logicId, obj)
        }
        console.log(`setRouting ${logicId} | ${pageQuestion.id}`)
    }

    generateSkipRules = (skiplogic, json) => {
        skiplogic.keys().forEach((skipKey) => {
            const ruleJson = {
                groups: [
                    {
                        rules: [],
                    },
                ],
            }
            const rule = skiplogic.get(skipKey)
            const sets = skipKey.split('|')
            const t = {
                pageId: rule.value,
                set1: sets[0],
                pageQuestionId: rule.questionId,
                equalityOperator: '=',
            }
            if (sets.length > 1) {
                t.set2 = sets[1]
            }
            ruleJson.groups[0].rules.push(t)
            json.data.groups.push(ruleJson)
        })
    }

    discard = () => {
        const { store } = this.props
        const { skipLogic } = this
        store.skipLogic = []
        Object.keys(skipLogic).forEach((logicId) => {
            store.skipLogic.push(skipLogic[logicId])
        })
        // store.showPageRouting = false
        store.skiplogicDiscardConfirm = true
    }

    cancel = () => {
        const { skipLogic } = this.page
        skipLogic.reset()
    }

    optionColumn = (option, col, pageQuestion, index, title) => {
        const { store } = this.props
        const logicId = option.id + (col ? (`|${col.id}`) : '')
        console.log('optionColumn')
        console.log(Object.keys(this.selections))
        console.log(logicId)
        // console.log(`getPage ${option.parentId}`)
        const key = `optioncolumn_${index}`

        if (store.skipLogicConfig.type === 'page' && !this.selections.has(logicId)) return null

        return (
            <Fragment>
                <br />

                <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        {title}
                    </div>

                    <div style={{ width: '30%' }}>
                        <Select
                            label={i18n.t('skipLogicModal.pageRoute')}
                            showDisabled={store.skipLogicConfig.type === 'page'}
                            clearable={false}
                            options={this.page_options}
                            value={this.selections.has(logicId) ? this.selections.get(logicId) : { value: -1, label: i18n.t('form.general.please_select_ellipsis') }}
                            onBlur={(obj) => this.setRouting(option, obj, col, pageQuestion)}
                        />
                    </div>
                </div>

                <br />
            </Fragment>
        )
    }

    optionGrid = (option, cols, pageQuestion, initLocale) => {
        const { store } = this.props
        const { survey } = store
        const optionId = option.id
        const rows = cols.map((optionCol, index) => {
            const logicId = `${optionId}|${optionCol.id}`
            const key = `${optionId}_optiongrid_row_${index}`
            const { initialLocale } = pageQuestion.question

            if (store.skipLogicConfig.type === 'page' && !this.selections.has(logicId)) return null

            return (
                <div>
                    <br />

                    <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            {optionCol.getTitle(store.surveyLocale, survey.metadata.defaultLocale, initialLocale)}
                        </div>

                        <div style={{ width: '30%' }}>
                            <Select
                                label={i18n.t('skipLogicModal.pageRoute')}
                                showDisabled={store.skipLogicConfig.type === 'page'}
                                clearable={false}
                                options={this.page_options}
                                value={this.selections.get(logicId) || { value: -1, label: i18n.t('form.general.please_select_ellipsis') }}
                                onBlur={obj => this.setRouting(option, obj, optionCol, pageQuestion) }
                            />
                        </div>
                    </div>

                    <br />

                    <hr />
                </div>
            )
        })

        if (rows.every((row) => row === null)) return null

        return (
            <div style={{ marginTop: '24px' }}>
                <div style={{ fontWeight: 'bold' }}>
                    {option.getTitle(store.surveyLocale, survey.metadata.defaultLocale, initLocale)}
                </div>

                <br />

                <hr />

                <div>
                    {rows}
                </div>
            </div>
        )
    }

    addHead = (question) => {
        const { store } = this.props
        const { survey } = store
        const cols = question instanceof DoubleAxisQuestion ? question.optionSetX.options : []
        const { initialLocale } = question.metadata
        return (
            <div>
                {
                    cols.map(col => (<div>{col.getTitle(store.surveyLocale, survey.metadata.defaultLocale, initialLocale)}</div>))
                }
            </div>
        )
    }

    optionSelection = ({
        option,
        cols,
        index,
        pageQuestion,
    }) => {
        const { store } = this.props
        const { survey } = store
        const { question } = pageQuestion
        const { initialLocale } = question.metadata
        const key = `optionselection_${index}`

        return (
            <div key={key}>
                { question instanceof DoubleAxisQuestion
                    ? (
                        <div>
                            {this.optionGrid(option, cols, pageQuestion, initialLocale)}
                        </div>
                    ) : (
                        <div>
                            {cols.map((col) => this.optionColumn(
                                option,
                                col,
                                pageQuestion,
                                index,
                                option.getTitle(store.surveyLocale, survey.metadata.defaultLocale, initialLocale),
                            ))}
                        </div>
                    )
                }
            </div>
        )
    }

    optionSection = (pageQuestion) => {
        const { store } = this.props
        const { survey } = store
        const { question, parentId } = pageQuestion
        const cols = question instanceof DoubleAxisQuestion ? question.optionSetX.options : ['']
        const { options } = question instanceof DoubleAxisQuestion ? question.optionSetY : question.optionSet
        const questionOptions = options.slice()
        if (parentId) {
            const parentOptions = survey.pages.reduce((po, surveyPage) => {
                if (surveyPage.questions) {
                    const pageQuestion = surveyPage.questions.find(q => q.id.toLowerCase() === parentId.toLowerCase())
                    if (pageQuestion) {
                        console.log(JSON.stringify(pageQuestion))
                        console.log(JSON.stringify(pageQuestion.question))
                        po = R.pathOr([], ['question', 'optionSet', 'options'], pageQuestion)
                    }
                }
                return po
            }, [])
            console.log(`has parent ${parentId} `)
            parentOptions.forEach((option) => {
                const po = Object.assign(option, { parentId })
                console.log(parentId, option.id)
                if (!po.isExclusive) {
                    questionOptions.push(po)
                }
            })
        }
        console.log(questionOptions.map((option) => [option.id, option.parentId]))

        return (
            <div style={{ backgroundColor: 'white', color: 'black', padding: 20 }}>
                <div className="full">
                    {
                        questionOptions.map((option, index) => this.optionSelection({
                            option,
                            cols,
                            index,
                            pageQuestion,
                        }))
                    }
                </div>
            </div>
        )
    }

    questionSection = (pageQuestion, index) => {
        const that = this
        const { store } = this.props
        const { survey } = store
        const surveyLocale = { store }
        const { question } = pageQuestion
        const key = `questionsection_${index}`
        if (store.skipLogicConfig.type === 'page') {
            const questionHasPageLogic = store.survey.skipLogic.find((sl) => (sl.action.kind === 'SkipToPage' && R.pathOr('', ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'pageQuestionId'], sl) === R.pathOr('', ['id'], pageQuestion)))

            if (!questionHasPageLogic) return null
        }

        return (
            <div key={key} id={key}>
                <div style={{ overflow: 'hidden', height: 60, display: 'flex', gap: 40, alignItems: 'center', fontWeight: 'bold', backgroundColor: '#FAFBFC', color: 'black' }}>
                    <div className={`skip-logic-question-color q_${question.metadata.oid}`} />

                    {question.content.getTitleByLocale('shortTitle', surveyLocale, survey.metadata.defaultLocale)}
                </div>
                {that.optionSection(pageQuestion)}
            </div>
        )
    }

    shouldQuestionAppear = (question) => {
        const { store } = this.props
        const { skipLogicConfig } = store

        if (
            (skipLogicConfig.type === 'question' ? question.id === skipLogicConfig.question.id : true)
            && question.isMulti()
            && (
                !question.isHidden
                || question.hasPopulateFrom
            )
            && question.questionType() !== 'OD'
        ) {
            return true
        }

        return false
    }

    render() {
        const { store } = this.props

        const questionSections = this.page.questions.map((pageQuestion, index) => (
            this.shouldQuestionAppear(pageQuestion) ? this.questionSection(pageQuestion, index) : null
        ))

        return (
            <PageRoutingWrapper skipLogicConfig={store.skipLogicConfig} hide={questionSections.every((section) => section === null)}>
                <div>
                    <div>
                        <Fragment>
                            {questionSections}
                        </Fragment>
                    </div>
                </div>
            </PageRoutingWrapper>
        )
    }
}

export default PageRouting
